import { PostAddOutlined } from "@mui/icons-material";
import React, { memo } from "react";
import { useDispatch } from "react-redux";
import { openElement } from "../../../../../../store/features/base/modalsSlice";
import CustomFab from "../../../../../buttons/CustomFab";

const CreationFab = ({ role = "", expanded }) => {
  const dispatch = useDispatch();
  return (
    <>
      <CustomFab
        onClick={() => {
          dispatch(
            openElement({
              name: "modalCreateReport",
              payload: {
                role,
              },
            })
          );
        }}
        Icon={PostAddOutlined}
        label={"Gerar novo"}
        expanded={expanded}
      />
    </>
  );
};

export default memo(CreationFab);
